<template>
	<div id="system">
		<div class="system_banner">
			<img src="http://img.anxuan360.com/Fth7h-SeabT1JuBEKhKBFRnJKqgf" alt="" />
		</div>
		<div class="centre flexLR">
			<div class="l">
				<ul class="navL">
					<li v-for="(item,index) in chanpinNav" :class="['clickStyle',activeIndex==index?'active':'']" @click="navClick(index)" @mouseover="item.hover=false" @mouseout="item.hover=true">
						<a :href="item.href" style="height: 0;width: 0;display: block;overflow: hidden;">{{item.name}}</a>
						<img :src="[!item.hover||activeIndex==index?item.img1:item.img]" alt="" />
						<span>{{item.name}}</span>
					</li>
				</ul>
				<div class="loveL">
					<p><i></i><span>猜你喜欢</span></p>
					<div class="navImg clickStyle" v-for="(item,index) in navImg" @click="navTo(item.uid)">
						<a :href="item.href" style="height: 0;width: 0;display: block;overflow: hidden;">{{item.name}}</a>
						<img :src="item.img" alt="" />
						<p>{{item.name}}</p>
					</div>
				</div>
				<div class="loveL">
					<p><i></i><span>联系我们</span></p>
					<div class="text">
						<p class="p1 mb20">浙江安宣信息技术有限公司</p>
						<p class="p2 mb20">电话:0571-87357305</p>
						<p class="p2 mb20">地址:浙江省杭州市西湖区西园八路11号一期D座506-507</p>
						<p class="p2">网址:www.ax168.com</p>
					</div>
				</div>
			</div>
			<div class="r">
				<systemContent1 ref="mychild" :activeIndex='activeIndex'></systemContent1>
			</div>
		</div>
		<div class="centre anli mb20">
			<p class="title ">
				<i></i>
				<span>客户案例</span>
			</p>
			<div class="anliBox ">
				<div class="anliList" v-for="(item,index) in anliList">
					<img :src="item.img" alt="" />
					<p class="p1">{{item.title}}</p>
					<p class="p2 sl2">{{item.text}}</p>
					<router-link tag="a" target="_blank" :to="{name:'marketC',query:{activeIndex:index}}" class="xiangqing clickStyle">
						<a :href="item.href" style="height: 0;width: 0;display: block;overflow: hidden;">{{item.title}}</a>
						查看详情
					</router-link>
				</div>

			</div>
		</div>
		<div class="centre shebei youlan">
			<p class="title ">
				<i></i>
				<span>最近游览</span>
			</p>
			<div class="anliBox">
				<div class="swiper-container">
					<div class="swiper-wrapper contentB">
						<div class="swiper-slide shebeiList" v-for="(item,index) in youlanList">
							<img :src="item.img" alt="" />
							<p>{{item.name}}</p>
						</div>
					</div>
					<!-- Add Pagination -->
					<div class="swiper-pagination"></div>
				</div>

			</div>
		</div>

	</div>

</template>

<script>
	import systemContent1 from './systemContent1.vue'

	export default {
		metaInfo() {
			return {
				meta: [{
						name: 'renderer',
						content: 'http://www.ax168.com/system?activeIndex=' + this.activeIndex
					},
					{
						name: 'system',
						content: this.chanpinNav[this.activeIndex].name
					},
					{
						name: 'keywords',
						content: '智慧农贸,智慧市场，智慧菜场，电子追溯，电子支付，智慧农贸,数字农贸,智慧农贸市场,智慧城市,菜篮子,农贸市场管理,农贸市场管理系统,溯源单子秤,智慧菜场,智慧菜市场,智慧市场,农贸市场智慧化建设方案,智慧微菜场,农贸市场管理软件,智慧农贸电子秤,农贸市场管理软件,菜市场管理系统,菜市场管理软件,新型农贸市场,O2O菜场，重要产品追溯系统,智慧农贸信息化平台,食品追溯监管系统,企业产品追溯系统,农产品追溯系统,仓储配送系统,智慧支付系统'
					},
					{
						name: 'description',
						content: '浙江安宣信息技术有限公司，国家高新技术企业，咨询热线0571-87357305，智慧菜场、智慧农贸、智慧农批、智慧市场、食品安全信息化监管和食品安全追溯平台以及农贸O2O电商平台。'
					}
				]
			}
		},
		data() {
			return {
				activeIndex: 0,
				message: "",
				youlanList: [{
						img: 'http://img.anxuan360.com/FqVbBhdE9sXe_aRtLWzuIzPtzj3o',
						name: '智能追溯电子秤'
					},
					{
						img: 'http://img.anxuan360.com/Fo5CUvBvsgQ1Mu0jUWtg_dBSmjV4',
						name: '共享磅秤'
					},
					{
						img: 'http://img.anxuan360.com/FpuDSqFyG6vA5_u1d2BMeQJE3cyq',
						name: '查询机'
					},
					{
						img: 'http://img.anxuan360.com/FsRVb25BHdT7exc-_oSRqOZkYXrf',
						name: '食品安全快速检测仪'
					},
					{
						name: '支付码牌',
						img: 'http://img.anxuan360.com/FuIj4OcDMeeayDfjUs7lfLOXjkOA'
					}, {
						name: "POS机",
						img: 'http://img.anxuan360.com/Fj5NXCjBzLwVvhdDMH763QFdXuKm'
					}
				],
				anliList: [{
					img: 'http://img.anxuan360.com/Fo7akFVPR7qd0LwCDfTZDco8ytPc',
					title: '府苑新村农贸市场',
					text: '府苑新村农贸市场每个摊位都配备着智能显示屏，上面显示摊主的信息食材价格检测结果等，力求让顾客买得放心，吃得安心。',
					href: 'http://www.ax168.com/marketC?activeIndex=0'
				}, {
					img: 'http://img.anxuan360.com/FhWQviap3GhCaNsU_jONs7a2H8nv',
					title: '东阳西门市场',
					text: '以后到“智慧菜场”买菜再也不会被支付方式困扰了，一个二维码就可以解决。我局联合东阳农商银行推出了“丰收一码通”。消费者可以选择微信、支付宝以及丰收互联APP任意一种方式付款。“花式”付款，就是这么任性！',
					href: 'http://www.ax168.com/marketC/activeIndex=1'
				}, {
					img: 'http://img.anxuan360.com/FjOQU9vwycNFrHmdhkuo3VjsyOjA',
					title: '义乌词林菜场',
					text: '9月19日，全省农批市场食品安全规范化建设现场推进会在义乌召开。省食品安全委员会办公室专职副主任、省食品药品监督管理局副局长卢永福出席会议并讲话，省财政厅、省食品药品监督管理局相关处室负责人及全省各地市市场监督管理局相关负责人、食用农产品批发市场（简称“农批市场”）负责人共110人参加会议。',
					href: 'http://www.ax168.com/marketC/activeIndex=2'
				}, {
					img: 'http://img.anxuan360.com/FiIKWKZpysQZYr-xb1JRzzMAH8-F',
					title: '磐安安文蔬菜市场',
					text: '为了让新市场达到规范经营、放心购买、安全食用的目标，该县市场监管局与农商银行合作，推出两大实招：一是推进食品溯源系统建设。实现市场内经营户的电子秤与农商银行一码通产品相互连接，消费者通过扫码支付就能了解到食品的安全情况，实现蔬菜从田间到商户交易全程可追溯。二是开展商户电子交易激励活动。',
					href: 'http://www.ax168.com/marketC/activeIndex=3'
				}],
				navImg: [{
					img: 'http://img.anxuan360.com/FlXk6GgkNZfcnR4PUM-bdNIeDY-o',
					name: '食品检测系统',
					uid: 1,
					href: 'http://www.ax168.com/system?activeIndex=1'
				}, {
					img: 'http://img.anxuan360.com/Ft_3vX1qtIid_F2hiyIC720mck_v',
					name: '智能巡查系统',
					uid: 8,
					href: 'http://www.ax168.com/system?activeIndex=8'
				}, {
					img: 'http://img.anxuan360.com/FqWe6GGp4rUF70Di3Ak1rnYb5Kp4',
					name: '商家管理系统',
					uid: 3,
					href: 'http://www.ax168.com/system?activeIndex=3'
				}],
				chanpinNav: [{
					name: '食品追溯系统',
					img: 'http://img.anxuan360.com/Fp2vjQDQgA24wE7GURC02SQfjR1z',
					img1: 'http://img.anxuan360.com/FrP4mnbpJvCcdp1lKwwxtNnXLdHV',
					path: '/system',
					hover: true,
					navClick: false,
					href: 'http://www.ax168.com/system?activeIndex=0',
				}, {
					name: '食品检测系统',
					img: 'http://img.anxuan360.com/FlnDdxD2ezHlx0RhsSmCGt_FNByA',
					img1: 'http://img.anxuan360.com/FsmkxKY8R0umMRoOKydijx_R9oUq',
					path: '/system',
					hover: true,
					navClick: false,
					href: 'http://www.ax168.com/system?activeIndex=1',
				}, {
					name: '市场运营系统',
					img: 'http://img.anxuan360.com/FnWbERioaahtcpwj9Ped3jq7M5u8',
					img1: 'http://img.anxuan360.com/FhWxC2oboxzA3IZnH8aV1yNwjUxV',
					path: '/system',
					hover: true,
					navClick: false,
					href: 'http://www.ax168.com/system?activeIndex=2',
				}, {
					name: '商家管理系统',
					img: 'http://img.anxuan360.com/FqO_1UNmbSl4p8I4KYF8_zhNeTzf',
					img1: 'http://img.anxuan360.com/Fgi11OuINY4xcO5LCO1-ebjl8PUN',
					path: '/system',
					hover: true,
					navClick: false,
					href: 'http://www.ax168.com/system?activeIndex=3',
				}, {
					name: '会员营销系统',
					img: 'http://img.anxuan360.com/Fs3cz2hxGF-R9x4C0uVUzu_gZ_6_',
					img1: 'http://img.anxuan360.com/FiQjdRS12aD28ojxUj7tKH7k9q5Q',
					path: '/system',
					hover: true,
					navClick: false,
					href: 'http://www.ax168.com/system?activeIndex=4',
				}, {
					name: '网上菜场系统',
					img: 'http://img.anxuan360.com/FhLUK3rY40zRuLtN6OYbvxPirPV2',
					img1: 'http://img.anxuan360.com/FmbzJJZud_XxJo_41_Y6RqNlvIag',
					path: '/system',
					hover: true,
					navClick: false,
					href: 'http://www.ax168.com/system?activeIndex=5',
				}, {
					name: '市场招商系统',
					img: 'http://img.anxuan360.com/Fsx5pk7vznD2Kv5Ow657Eb8ki-Y9',
					img1: 'http://img.anxuan360.com/FjyXTpyIXaD4dgFkFi0rIgMiAVUQ',
					path: '/system',
					hover: true,
					navClick: false,
					href: 'http://www.ax168.com/system?activeIndex=6',
				}, {
					name: '电子结算系统',
					img: 'http://img.anxuan360.com/FrWchsOOfj64DNLb0qFsMKcekLKl',
					img1: 'http://img.anxuan360.com/Fhr8ruGzyp7ppXTgAwMkl_3Dc9jL',
					path: '/system',
					hover: true,
					navClick: false,
					href: 'http://www.ax168.com/system?activeIndex=7',
				}, {
					name: '智能巡查系统',
					img: 'http://img.anxuan360.com/FrOqczbTSzbtqsptHqz6WDTXD9D4',
					img1: 'http://img.anxuan360.com/Fn7LDCVXXLmXY2YiBE-7Osn7muuA',
					path: '/system',
					hover: true,
					navClick: false,
					href: 'http://www.ax168.com/system?activeIndex=8',
				}, {
					name: '数据展示系统',
					img: 'http://img.anxuan360.com/FlVOV-2YgdEeTtSwFbWhhzw6pioU',
					img1: 'http://img.anxuan360.com/Fo-x-waAnmfD9ntlnt2-QGf4IpVG',
					path: '/system',
					hover: true,
					navClick: false,
					href: 'http://www.ax168.com/system?activeIndex=9',
				}, {
					name: '智慧农场系统',
					img: 'http://img.anxuan360.com/Fp6I_II6cYmCPWQxK1Srlp2LqSIS',
					img1: 'http://img.anxuan360.com/FrJN4fze0vnCcVsJCeIEL8FCzoNo',
					path: '/system',
					hover: true,
					navClick: false,
					href: 'http://www.ax168.com/system?activeIndex=10',
				}, {
					name: '智慧禽畜系统',
					img: 'http://img.anxuan360.com/FjV3eJbn4uzH3K4-G7zjCoNHQLA2',
					img1: 'http://img.anxuan360.com/FofaSQVIsrVMAiBiS7V-sB0WCPOp',
					path: '/system',
					hover: true,
					navClick: false,
					href: 'http://www.ax168.com/system?activeIndex=11',
				}, {
					name: '智慧水产系统',
					img: 'http://img.anxuan360.com/FogZKVI4v6o-IJGwFn-pnLnbmQ6e',
					img1: 'http://img.anxuan360.com/FnMiMNQLlO3ZUn6gyi1vcRM-0aod',
					path: '/system',
					hover: true,
					navClick: false,
					href: 'http://www.ax168.com/system?activeIndex=12',
				}],
			}
		},
		mounted: function() {
			this.activeIndex = this.$route.query.activeIndex - 0
				this.$refs.mychild.navClick(this.activeIndex);
			var swiper = new Swiper('.swiper-container', {
				slidesPerView: 5.2,
				paginationClickable: true,
				spaceBetween: 20
			});
		},
		activated() {
			document.documentElement.style.fontSize = "";
		},
		methods: {
      handNavGx(){
        window.open("https://beian.miit.gov.cn", '_blank')
      },
			navClick(index) {
				this.activeIndex = index;
				this.$refs.mychild.navClick(this.activeIndex);
			},
			navTo1(index) {
				//					window.open('marketC/' + index);
			},
			navTo(index) {
				this.$router.push({
					path: '/system',
					query: {
						activeIndex: index
					},
				})
			},
		},
		watch: {
			$route(to, from) {
				if(to.name == 'system') {

					this.activeIndex = to.query.activeIndex
				}
			}
		},
		components: {
			systemContent1
		}
	}
</script>

<style>
	@import url('../../css/system.css');
	.swiper-container {
		width: 100%;
		height: 100%;
	}

	.system_banner {
		height: 688px;
	}

	.swiper-slide {
		text-align: center;
		font-size: 18px;
		background: #fff;
	}

	#system .shebei .contentB .shebeiList>img {
		margin: 0 auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/system/system.vue